import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "routines",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "course-routines" */ "./components"),
        import(
          /* webpackChunkName: "course-routinesFeed" */ "./modules/RoutinesModule"
        ),
        import(
          /* webpackChunkName: "course-routinesDetail" */ "AppComponents/Routines/modules/RoutineModule"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        const routine = importedModule2.default;
        injectReducer(store, {
          key: "routine",
          reducer: routine,
        });
        injectReducer(store, {
          key: "routinesFeed",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [],
});
